module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "bot-slide",
    class: _vm.botActive ? 'slide-active' : '',
    on: {
      "click": function($event) {
        _vm.botClick()
      }
    }
  }, [_c('div', {
    staticClass: "bot-slider"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4ff30c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/BotSlide.vue
// module id = 1045
// module chunks = 1